import { Button, Col, Form, Row, Input } from "antd";
import ModalComponent from "../ModalComponent";
import { generateUUID, showNotitfication } from "../../utils/Utils";
import {
  toGetYougotaGiftKeys,
  toSendYouGotaGift,
  toSendYouGotaGiftData,
} from "../../apis/actions/paymentMethods.actions";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../apis/store";
import { useTranslation } from "react-i18next";
import {
  toGetMyWalletHistory,
  toGetProfil,
} from "../../apis/actions/auth.actions";
import { useEffect } from "react";

interface Props {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}
interface YouGotaGiftConfig {
  username: string;
  password: string;
  baseUrl: string;
}

interface RedeemGiftCardData {
  store_staff_position: string;
  store_staff_name: string;
  store_location: string;
  code: string;
  reference_id: string;
  config: YouGotaGiftConfig;
}

const YouGotaGiftPayment = ({ isOpen, setIsOpen }: Props) => {
  const dispatch = useDispatch<AppDispatch>();
  const [form] = Form.useForm();
  const { t, i18n } = useTranslation();
  useEffect(() => {
    dispatch(toGetYougotaGiftKeys());
  }, [dispatch]);
  const { data } = useSelector(
    (state: RootState) => state.tabby.YougotaGiftKeys
  );
  const handleGift = async () => {
    try {
      await form.validateFields();
      const values = form.getFieldsValue();

      const config = {
        username: data?.Username,
        password: data?.Password,
        baseUrl: data?.baseURL,
      };

      const payload: RedeemGiftCardData = {
        store_staff_position: "Online",
        store_staff_name: "Auto Chapeau",
        store_location: "Auto Chapeau",
        code: values.card_number,
        reference_id: generateUUID(),
        config,
      };

      const response = (await dispatch(toSendYouGotaGift(payload))) as any;
      const gift = response?.payload;

      if (gift?.code) {
        showNotitfication(t("yougotagift.success"), "success");
        form.resetFields();
        await dispatch(toSendYouGotaGiftData(gift));
        setIsOpen(false);
        dispatch(toGetMyWalletHistory());
        await dispatch(toGetProfil(i18n.language));
      } else if (gift?.errors?.error_code == 1002) {
        showNotitfication(t("yougotagift.error_1002"), "error");
      } else if (gift?.errors?.error_code == 1005) {
        showNotitfication(t("yougotagift.error_1005"), "error");
      } else if (gift?.errors?.error_code == 1003) {
        showNotitfication(t("yougotagift.error_1003"), "error");
      } else {
        showNotitfication(gift?.errors?.message, "error");
      }
    } catch (error) {
      console.error("Gift Card Redemption Error:", error);
    }
  };

  return (
    <ModalComponent
      destroyOnClose
      title={t("yougotagift.redeem_gift_card")}
      open={isOpen}
      onClose={() => setIsOpen(false)}
      closeOnOutsideClick={true}
      width={500}
      centered={true}
      canvasBackdrop
    >
      <Form form={form} layout="vertical" className="mt-20">
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              label={t("yougotagift.card_number")}
              name="card_number"
              rules={[
                { required: true, message: t("yougotagift.input_card_number") },
              ]}
            >
              <Input placeholder={t("yougotagift.enter_card_number")} />
            </Form.Item>
          </Col>
        </Row>

        <Row className="mt-20" justify="end">
          <Button
            className="text-md ac--btn-edit-save"
            type="primary"
            onClick={handleGift}
          >
            {t("yougotagift.validate_redeem")}
          </Button>
        </Row>
      </Form>
    </ModalComponent>
  );
};

export default YouGotaGiftPayment;
